import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            organizationname:'',//组织名称
            organizationtype:'',//组织类型
            fullname:'',//组织负责人
            uporganization:'',//所属上级组织
            uporganizationcode:'',//所属上级组织编码
            isvalidity:''//有效性
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        //查询系统列表信息
        selectOrg(context, payload) {
            return D.select({
                ...payload
            })

        },
        //查询上级组织
        queryUporg(context, payload) {
            return D.select({
                ...payload
            })

        },
        queryUser(context, payload) {
            return D.select({
                ...payload
            })

        },
        
        //组织有效无效
        activeOrg(context, payload) {
            return D.del({
                ...payload
            })
        },
        //编辑，查看
        detailOrg(context, payload) {
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                data.nchecked = data.isvalidity == '1';
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
  
        },
        getEmptyOrg(context){
            context.commit({
                type: 'save',
                payload: {
                    record: {
                        uporganizationname:'',
                        fullname:''
                    }
                }
            })
        },

        // 更新任务
        updateAddTask(context, payload) {
            return D.edit({
                ...payload
            })
        },
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        organizationname:'',//组织名称
                        organizationtype:'',//组织类型
                        fullname:'',//组织负责人
                        uporganization:'',//所属上级组织
                        isvalidity:''//有效性
                    }
                }
            })
        },
        
    }
}